import React ,{useEffect} from 'react'
import { useMutation } from '@apollo/client'
import { COUNTGLOBAL } from '../../../gql/global'
import useAuth from '../../../hooks/useAuth';
import { Image,Grid, GridColumn,Segment, Container} from 'semantic-ui-react';
import icona from "../../../asets/png/icona.jpg"
import "./Visitas.scss"



export default function Visitas(props) {
    const{getGlobal,globals,auth1}= props
    const {auth} = useAuth();
    
    var time = ( new Date(getGlobal[0].createAt*1)).toLocaleTimeString()
    var time2 = ( new Date(getGlobal[0].createAt*1)).toLocaleDateString()
    

    const [updateGlobal, refetch] = useMutation (COUNTGLOBAL);
    useEffect(() => {
   console.log ("jkl")
        try {

        
            updateGlobal({
              variables:{	input:{
                id:"67355bb3437eedf7b8e59490",
                countInt:globals[0].count + 1 ,
                createAt:new Date(),
                idUser:auth1,
                idUserAnt:globals[0].user1.id,
                idUserAnt2:globals[0].user2.id,
                //createAt2:new Date(),
        
              }},
        
              
            });
        
           window.relodad ()
          } catch (error) {
            console.log (error);
            
          }
  
    
      
    }, [])
    
    


  return (
    <>

<h3>Visitas  👣  🐾   👣 </h3>  



<div className='homer_do'>
 


<div className='homeru'>
<Image   src= {globals[0].user1.avatar || icona } circular />
        <span> {globals[0].user1.username}</span>
        </div>       

        

<div className='homeru'>
<Image   src= {globals[0].user2.avatar || icona } avatar />
        <span> {globals[0].user2.username}</span>
        
</div>

<div className='homeru'>
<Image   src= {globals[0].user3.avatar || icona } avatar />
        <span> {globals[0].user3.username}</span>
        
</div>






</div>

<div className='cont'>
  <div class="ui teal circular  segment" className='conti'>
    <div className='conti'>
        <div class="title"> 👁️ {globals[0].count}</div>
        <div class="description">{time2}</div>
        <span>🕖 {time}</span>
    </div>
  </div>
  
      </div>
    
  
</>
    
  )
}
